// Foundations
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

// Icons
import { faTimes } from '@fortawesome/free-solid-svg-icons';

// Services
import { GoogleMapsService } from 'src/app/services/google-maps.service';
import { AnalyticsService } from '../../../services/analytics.service';
import { CampHoursUtilsService } from 'src/app/services/utils/camp-hours-utils.service';

// Models
import { FranchiseLocation } from 'src/app/models/franchise.model';

@Component({
  selector: 'app-camp-details-dialog',
  templateUrl: './camp-details-dialog.component.html',
  styleUrls: ['./camp-details-dialog.component.scss'],
})
export class CampDetailsDialogComponent implements OnInit {
  faTimes = faTimes;

  locationData: FranchiseLocation;
  isPreferred: false;

  locationHoursOfOperationsData;
  locationHours;

  constructor(
    public googleMapsService: GoogleMapsService,
    private _analytics: AnalyticsService,
    private dialogRef: MatDialogRef<CampDetailsDialogComponent>,
    private router: Router,
    private _campHoursUtilsService: CampHoursUtilsService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit() {
    this.locationData = this.data.locationData;
    this.isPreferred = this.data.isPreferred;

    // Try to parse the "camp hours" info
    this.locationHoursOfOperationsData =
      this.locationData.hoursOfOperation || {};
    this.locationHours = this._campHoursUtilsService.buildCampHoursDisplayInfo(
      this.locationHoursOfOperationsData
    );
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  navigateToReservation() {
    this._analytics.logButtonTap('campDetails_bookReservation');
    this.dialogRef.close();
    this.router.navigate(['/reservation'], {
      queryParams: { campId: this.locationData.id },
    });

    // TODO: add router.navigate when Reservation is finished
  }

  navigateToInterviewRequest() {
    this._analytics.logButtonTap('landing_requestInterview');
    this.dialogRef.close();
    this.router.navigate(['/interview-request'], {
      queryParams: { campId: this.locationData.id },
    });
  }

  navigateToCampWebsite() {
    this._analytics.logButtonTap('campDetails_visitWebsite');
    this.dialogRef.close();
    window.open(this.locationData.websiteUrl);
  }

  navigateToCamperCams() {
    this._analytics.logButtonTap('campDetails_watchCamperCam');
    this.dialogRef.close();
    this.router.navigate(['/camper-cams'], {
      queryParams: { campId: this.locationData.id },
    });
  }
}
